import { AppDispatch } from '../store';
import { FinishedState } from '../../types/session';
import { sdkCallbacks } from '../../features/session/sdk-callbacks';
import { callbackRegistry } from '../../features/session/callback-registry';
import { reportError } from '../slices/error.slice';
import { changeSessionState } from '../slices/session.slice';

export const finish = (state: FinishedState) => {
	return async (dispatch: AppDispatch) => {
		try {
			await sdkCallbacks.execute('onFinished');
		} catch (error: any) {
			reportError({ type: 'TECHNICAL', reason: error, message: 'We are experiencing some technical issues.' });
		}

		callbackRegistry.retrieve('onFinished')();
		dispatch(changeSessionState(state));
	};
};
